export const StoreState = {
    event:'event'
}

export const state = {
    [StoreState.event]:null
}
